import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloFeedDownload, cleanAloFeedDownload } from '@/models/alo/AloFeedDownload'
import { ApiResultCode } from '@/enum/ApiResultCode'

export default {
  getAllFeedDownload(): AxiosPromise<AlrContainer<Array<AloFeedDownload>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/FeedDownload`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloFeedDownload>>
      }]
    })
  },
  getFeedDownload(id:number):AxiosPromise<AlrContainer<AloFeedDownload>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/FeedDownload/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloFeedDownload>
      }]
    })
  },
  saveFeedDownload(feedDownload:AloFeedDownload):AxiosPromise<AlrContainer<AloFeedDownload>> {
    cleanAloFeedDownload(feedDownload)
    if(feedDownload.id) {
      const oldId = feedDownload.id
      feedDownload.id = feedDownload.newId
      delete feedDownload.newId
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/FeedDownload/${oldId}`, 
        method: 'PUT',
        data: feedDownload,
        transformResponse: [function (data:string) {   
          const  resp = JSON.parse(data) as AlrContainer<AloFeedDownload>     
          if(resp.resultCode == ApiResultCode.Ok){
            //@ts-ignore
            resp.data.newId = oldId
          }  
          return resp
        }]
      })    
    }
    else{
      feedDownload.id = feedDownload.newId
      delete feedDownload.newId
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/FeedDownload`, 
        method: 'POST',
        data: feedDownload,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloFeedDownload>
        }]
      })    
    }
  },
  deleteFeedDownload(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/FeedDownload/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<number>
      }]
    })
  }
}